import { createElement, Component } from 'react';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defineProperty = _defineProperty;
var defineProperty$1 = /*#__PURE__*/Object.freeze({
  default: defineProperty,
  __moduleExports: defineProperty
});
var defineProperty$2 = defineProperty$1 && defineProperty || defineProperty$1;
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      defineProperty$2(target, key, source[key]);
    });
  }
  return target;
}
var objectSpread = _objectSpread;
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var _extends_1 = createCommonjsModule(function (module) {
  function _extends() {
    module.exports = _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  module.exports = _extends;
});
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;
var objectWithoutPropertiesLoose$1 = /*#__PURE__*/Object.freeze({
  default: objectWithoutPropertiesLoose,
  __moduleExports: objectWithoutPropertiesLoose
});
var objectWithoutPropertiesLoose$2 = objectWithoutPropertiesLoose$1 && objectWithoutPropertiesLoose || objectWithoutPropertiesLoose$1;
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var objectWithoutProperties = _objectWithoutProperties;
var runtime = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  !function (global) {
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var runtime = global.regeneratorRuntime;
    if (runtime) {
      {
        // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        module.exports = runtime;
      }
      // Don't bother evaluating the rest of this file if the runtime was
      // already defined globally.
      return;
    }

    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global.regeneratorRuntime = module.exports;
    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []);

      // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.
      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }
    runtime.wrap = wrap;

    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";

    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};

    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}

    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        prototype[method] = function (arg) {
          return this._invoke(method, arg);
        };
      });
    }
    runtime.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction ||
      // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    runtime.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        if (!(toStringTagSymbol in genFun)) {
          genFun[toStringTagSymbol] = "GeneratorFunction";
        }
      }
      genFun.prototype = Object.create(Gp);
      return genFun;
    };

    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    runtime.awrap = function (arg) {
      return {
        __await: arg
      };
    };
    function AsyncIterator(generator) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;
          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return Promise.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }
          return Promise.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }
      var previousPromise;
      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new Promise(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
        // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }

      // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).
      this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };
    runtime.AsyncIterator = AsyncIterator;

    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function (innerFn, outerFn, self, tryLocsList) {
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
      return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };
    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }
        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          }

          // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
          return doneResult();
        }
        context.method = method;
        context.arg = arg;
        while (true) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }
            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }
          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);
          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;
            if (record.arg === ContinueSentinel) {
              continue;
            }
            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted;
            // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.
            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    }

    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];
      if (method === undefined) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;
        if (context.method === "throw") {
          if (delegate.iterator.return) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined;
            maybeInvokeDelegate(delegate, context);
            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }
          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }
        return ContinueSentinel;
      }
      var record = tryCatch(method, delegate.iterator, context.arg);
      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }
      var info = record.arg;
      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }
      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value;

        // Resume execution at the desired location (see delegateYield).
        context.next = delegate.nextLoc;

        // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.
        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      }

      // The delegate iterator is finished, so forget it and continue with
      // the outer generator.
      context.delegate = null;
      return ContinueSentinel;
    }

    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";

    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function () {
      return this;
    };
    Gp.toString = function () {
      return "[object Generator]";
    };
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      if (1 in locs) {
        entry.catchLoc = locs[1];
      }
      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }
      this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }
    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }
    runtime.keys = function (object) {
      var keys = [];
      for (var key in object) {
        keys.push(key);
      }
      keys.reverse();

      // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.
      return function next() {
        while (keys.length) {
          var key = keys.pop();
          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        }

        // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.
        next.done = true;
        return next;
      };
    };
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }
        if (typeof iterable.next === "function") {
          return iterable;
        }
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next() {
              while (++i < iterable.length) {
                if (hasOwn.call(iterable, i)) {
                  next.value = iterable[i];
                  next.done = false;
                  return next;
                }
              }
              next.value = undefined;
              next.done = true;
              return next;
            };
          return next.next = next;
        }
      }

      // Return an iterator with no values.
      return {
        next: doneResult
      };
    }
    runtime.values = values;
    function doneResult() {
      return {
        value: undefined,
        done: true
      };
    }
    Context.prototype = {
      constructor: Context,
      reset: function (skipTempReset) {
        this.prev = 0;
        this.next = 0;
        // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.
        this.sent = this._sent = undefined;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined;
        this.tryEntries.forEach(resetTryEntry);
        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined;
            }
          }
        }
      },
      stop: function () {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;
        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }
        return this.rval;
      },
      dispatchException: function (exception) {
        if (this.done) {
          throw exception;
        }
        var context = this;
        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;
          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined;
          }
          return !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;
          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function (type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }
        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;
        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }
        return this.complete(record);
      },
      complete: function (record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }
        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }
        return ContinueSentinel;
      },
      finish: function (finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function (tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }

        // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };
        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined;
        }
        return ContinueSentinel;
      }
    };
  }(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  function () {
    return this || typeof self === "object" && self;
  }() || Function("return this")());
});
var runtime$1 = /*#__PURE__*/Object.freeze({
  default: runtime,
  __moduleExports: runtime
});
var require$$0 = runtime$1 && runtime || runtime$1;

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = function () {
  return this || typeof self === "object" && self;
}() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;
var runtimeModule = require$$0;
if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch (e) {
    g.regeneratorRuntime = undefined;
  }
}
var runtimeModule$1 = /*#__PURE__*/Object.freeze({
  default: runtimeModule,
  __moduleExports: runtimeModule
});
var require$$0$1 = runtimeModule$1 && runtimeModule || runtimeModule$1;
var regenerator = require$$0$1;
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
var asyncToGenerator = _asyncToGenerator;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var classCallCheck = _classCallCheck;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var createClass = _createClass;
var _typeof_1 = createCommonjsModule(function (module) {
  function _typeof2(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof2 = function _typeof2(obj) {
        return typeof obj;
      };
    } else {
      _typeof2 = function _typeof2(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }
    return _typeof2(obj);
  }
  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      module.exports = _typeof = function _typeof(obj) {
        return _typeof2(obj);
      };
    } else {
      module.exports = _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      };
    }
    return _typeof(obj);
  }
  module.exports = _typeof;
});
var _typeof = /*#__PURE__*/Object.freeze({
  default: _typeof_1,
  __moduleExports: _typeof_1
});
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
var assertThisInitialized = _assertThisInitialized;
var assertThisInitialized$1 = /*#__PURE__*/Object.freeze({
  default: assertThisInitialized,
  __moduleExports: assertThisInitialized
});
var _typeof$1 = _typeof && _typeof_1 || _typeof;
var assertThisInitialized$2 = assertThisInitialized$1 && assertThisInitialized || assertThisInitialized$1;
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  }
  return assertThisInitialized$2(self);
}
var possibleConstructorReturn = _possibleConstructorReturn;
var getPrototypeOf = createCommonjsModule(function (module) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  module.exports = _getPrototypeOf;
});
var setPrototypeOf = createCommonjsModule(function (module) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  module.exports = _setPrototypeOf;
});
var setPrototypeOf$1 = /*#__PURE__*/Object.freeze({
  default: setPrototypeOf,
  __moduleExports: setPrototypeOf
});
var setPrototypeOf$2 = setPrototypeOf$1 && setPrototypeOf || setPrototypeOf$1;
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf$2(subClass, superClass);
}
var inherits = _inherits;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
var arrayWithoutHoles = _arrayWithoutHoles;
var arrayWithoutHoles$1 = /*#__PURE__*/Object.freeze({
  default: arrayWithoutHoles,
  __moduleExports: arrayWithoutHoles
});
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
var iterableToArray = _iterableToArray;
var iterableToArray$1 = /*#__PURE__*/Object.freeze({
  default: iterableToArray,
  __moduleExports: iterableToArray
});
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
var nonIterableSpread = _nonIterableSpread;
var nonIterableSpread$1 = /*#__PURE__*/Object.freeze({
  default: nonIterableSpread,
  __moduleExports: nonIterableSpread
});
var arrayWithoutHoles$2 = arrayWithoutHoles$1 && arrayWithoutHoles || arrayWithoutHoles$1;
var iterableToArray$2 = iterableToArray$1 && iterableToArray || iterableToArray$1;
var nonIterableSpread$2 = nonIterableSpread$1 && nonIterableSpread || nonIterableSpread$1;
function _toConsumableArray(arr) {
  return arrayWithoutHoles$2(arr) || iterableToArray$2(arr) || nonIterableSpread$2();
}
var toConsumableArray = _toConsumableArray;
var activestorage = createCommonjsModule(function (module, exports) {
  !function (t, e) {
    module.exports = e();
  }(commonjsGlobal, function () {
    return function (t) {
      function e(n) {
        if (r[n]) return r[n].exports;
        var i = r[n] = {
          i: n,
          l: !1,
          exports: {}
        };
        return t[n].call(i.exports, i, i.exports, e), i.l = !0, i.exports;
      }
      var r = {};
      return e.m = t, e.c = r, e.d = function (t, r, n) {
        e.o(t, r) || Object.defineProperty(t, r, {
          configurable: !1,
          enumerable: !0,
          get: n
        });
      }, e.n = function (t) {
        var r = t && t.__esModule ? function () {
          return t.default;
        } : function () {
          return t;
        };
        return e.d(r, "a", r), r;
      }, e.o = function (t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
      }, e.p = "", e(e.s = 2);
    }([function (t, e, r) {
      function n(t) {
        var e = a(document.head, 'meta[name="' + t + '"]');
        if (e) return e.getAttribute("content");
      }
      function i(t, e) {
        return "string" == typeof t && (e = t, t = document), o(t.querySelectorAll(e));
      }
      function a(t, e) {
        return "string" == typeof t && (e = t, t = document), t.querySelector(e);
      }
      function u(t, e) {
        var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          n = t.disabled,
          i = r.bubbles,
          a = r.cancelable,
          u = r.detail,
          o = document.createEvent("Event");
        o.initEvent(e, i || !0, a || !0), o.detail = u || {};
        try {
          t.disabled = !1, t.dispatchEvent(o);
        } finally {
          t.disabled = n;
        }
        return o;
      }
      function o(t) {
        return Array.isArray(t) ? t : Array.from ? Array.from(t) : [].slice.call(t);
      }
      e.d = n, e.c = i, e.b = a, e.a = u, e.e = o;
    }, function (t, e, r) {
      function n(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      function i(t, e) {
        if (t && "function" == typeof t[e]) {
          for (var r = arguments.length, n = Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) n[i - 2] = arguments[i];
          return t[e].apply(t, n);
        }
      }
      r.d(e, "a", function () {
        return c;
      });
      var a = r(6),
        u = r(8),
        o = r(9),
        s = function () {
          function t(t, e) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
          }
          return function (e, r, n) {
            return r && t(e.prototype, r), n && t(e, n), e;
          };
        }(),
        f = 0,
        c = function () {
          function t(e, r, i) {
            n(this, t), this.id = ++f, this.file = e, this.url = r, this.delegate = i;
          }
          return s(t, [{
            key: "create",
            value: function (t) {
              var e = this;
              a.a.create(this.file, function (r, n) {
                if (r) return void t(r);
                var a = new u.a(e.file, n, e.url);
                i(e.delegate, "directUploadWillCreateBlobWithXHR", a.xhr), a.create(function (r) {
                  if (r) t(r);else {
                    var n = new o.a(a);
                    i(e.delegate, "directUploadWillStoreFileWithXHR", n.xhr), n.create(function (e) {
                      e ? t(e) : t(null, a.toJSON());
                    });
                  }
                });
              });
            }
          }]), t;
        }();
    }, function (t, e, r) {
      function n() {
        window.ActiveStorage && Object(i.a)();
      }
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
      var i = r(3),
        a = r(1);
      r.d(e, "start", function () {
        return i.a;
      }), r.d(e, "DirectUpload", function () {
        return a.a;
      }), setTimeout(n, 1);
    }, function (t, e, r) {
      function n() {
        d || (d = !0, document.addEventListener("submit", i), document.addEventListener("ajax:before", a));
      }
      function i(t) {
        u(t);
      }
      function a(t) {
        "FORM" == t.target.tagName && u(t);
      }
      function u(t) {
        var e = t.target;
        if (e.hasAttribute(l)) return void t.preventDefault();
        var r = new c.a(e),
          n = r.inputs;
        n.length && (t.preventDefault(), e.setAttribute(l, ""), n.forEach(s), r.start(function (t) {
          e.removeAttribute(l), t ? n.forEach(f) : o(e);
        }));
      }
      function o(t) {
        var e = Object(h.b)(t, "input[type=submit]");
        if (e) {
          var r = e,
            n = r.disabled;
          e.disabled = !1, e.focus(), e.click(), e.disabled = n;
        } else e = document.createElement("input"), e.type = "submit", e.style.display = "none", t.appendChild(e), e.click(), t.removeChild(e);
      }
      function s(t) {
        t.disabled = !0;
      }
      function f(t) {
        t.disabled = !1;
      }
      e.a = n;
      var c = r(4),
        h = r(0),
        l = "data-direct-uploads-processing",
        d = !1;
    }, function (t, e, r) {
      function n(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      r.d(e, "a", function () {
        return s;
      });
      var i = r(5),
        a = r(0),
        u = function () {
          function t(t, e) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
          }
          return function (e, r, n) {
            return r && t(e.prototype, r), n && t(e, n), e;
          };
        }(),
        o = "input[type=file][data-direct-upload-url]:not([disabled])",
        s = function () {
          function t(e) {
            n(this, t), this.form = e, this.inputs = Object(a.c)(e, o).filter(function (t) {
              return t.files.length;
            });
          }
          return u(t, [{
            key: "start",
            value: function (t) {
              var e = this,
                r = this.createDirectUploadControllers();
              this.dispatch("start"), function n() {
                var i = r.shift();
                i ? i.start(function (r) {
                  r ? (t(r), e.dispatch("end")) : n();
                }) : (t(), e.dispatch("end"));
              }();
            }
          }, {
            key: "createDirectUploadControllers",
            value: function () {
              var t = [];
              return this.inputs.forEach(function (e) {
                Object(a.e)(e.files).forEach(function (r) {
                  var n = new i.a(e, r);
                  t.push(n);
                });
              }), t;
            }
          }, {
            key: "dispatch",
            value: function (t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return Object(a.a)(this.form, "direct-uploads:" + t, {
                detail: e
              });
            }
          }]), t;
        }();
    }, function (t, e, r) {
      function n(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      r.d(e, "a", function () {
        return o;
      });
      var i = r(1),
        a = r(0),
        u = function () {
          function t(t, e) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
          }
          return function (e, r, n) {
            return r && t(e.prototype, r), n && t(e, n), e;
          };
        }(),
        o = function () {
          function t(e, r) {
            n(this, t), this.input = e, this.file = r, this.directUpload = new i.a(this.file, this.url, this), this.dispatch("initialize");
          }
          return u(t, [{
            key: "start",
            value: function (t) {
              var e = this,
                r = document.createElement("input");
              r.type = "hidden", r.name = this.input.name, this.input.insertAdjacentElement("beforebegin", r), this.dispatch("start"), this.directUpload.create(function (n, i) {
                n ? (r.parentNode.removeChild(r), e.dispatchError(n)) : r.value = i.signed_id, e.dispatch("end"), t(n);
              });
            }
          }, {
            key: "uploadRequestDidProgress",
            value: function (t) {
              var e = t.loaded / t.total * 100;
              e && this.dispatch("progress", {
                progress: e
              });
            }
          }, {
            key: "dispatch",
            value: function (t) {
              var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return e.file = this.file, e.id = this.directUpload.id, Object(a.a)(this.input, "direct-upload:" + t, {
                detail: e
              });
            }
          }, {
            key: "dispatchError",
            value: function (t) {
              this.dispatch("error", {
                error: t
              }).defaultPrevented || alert(t);
            }
          }, {
            key: "directUploadWillCreateBlobWithXHR",
            value: function (t) {
              this.dispatch("before-blob-request", {
                xhr: t
              });
            }
          }, {
            key: "directUploadWillStoreFileWithXHR",
            value: function (t) {
              var e = this;
              this.dispatch("before-storage-request", {
                xhr: t
              }), t.upload.addEventListener("progress", function (t) {
                return e.uploadRequestDidProgress(t);
              });
            }
          }, {
            key: "url",
            get: function () {
              return this.input.getAttribute("data-direct-upload-url");
            }
          }]), t;
        }();
    }, function (t, e, r) {
      function n(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      r.d(e, "a", function () {
        return s;
      });
      var i = r(7),
        a = r.n(i),
        u = function () {
          function t(t, e) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
          }
          return function (e, r, n) {
            return r && t(e.prototype, r), n && t(e, n), e;
          };
        }(),
        o = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
        s = function () {
          function t(e) {
            n(this, t), this.file = e, this.chunkSize = 2097152, this.chunkCount = Math.ceil(this.file.size / this.chunkSize), this.chunkIndex = 0;
          }
          return u(t, null, [{
            key: "create",
            value: function (e, r) {
              new t(e).create(r);
            }
          }]), u(t, [{
            key: "create",
            value: function (t) {
              var e = this;
              this.callback = t, this.md5Buffer = new a.a.ArrayBuffer(), this.fileReader = new FileReader(), this.fileReader.addEventListener("load", function (t) {
                return e.fileReaderDidLoad(t);
              }), this.fileReader.addEventListener("error", function (t) {
                return e.fileReaderDidError(t);
              }), this.readNextChunk();
            }
          }, {
            key: "fileReaderDidLoad",
            value: function (t) {
              if (this.md5Buffer.append(t.target.result), !this.readNextChunk()) {
                var e = this.md5Buffer.end(!0),
                  r = btoa(e);
                this.callback(null, r);
              }
            }
          }, {
            key: "fileReaderDidError",
            value: function (t) {
              this.callback("Error reading " + this.file.name);
            }
          }, {
            key: "readNextChunk",
            value: function () {
              if (this.chunkIndex < this.chunkCount || 0 == this.chunkIndex && 0 == this.chunkCount) {
                var t = this.chunkIndex * this.chunkSize,
                  e = Math.min(t + this.chunkSize, this.file.size),
                  r = o.call(this.file, t, e);
                return this.fileReader.readAsArrayBuffer(r), this.chunkIndex++, !0;
              }
              return !1;
            }
          }]), t;
        }();
    }, function (t, e, r) {
      !function (e) {
        t.exports = e();
      }(function (t) {
        function e(t, e) {
          var r = t[0],
            n = t[1],
            i = t[2],
            a = t[3];
          r += (n & i | ~n & a) + e[0] - 680876936 | 0, r = (r << 7 | r >>> 25) + n | 0, a += (r & n | ~r & i) + e[1] - 389564586 | 0, a = (a << 12 | a >>> 20) + r | 0, i += (a & r | ~a & n) + e[2] + 606105819 | 0, i = (i << 17 | i >>> 15) + a | 0, n += (i & a | ~i & r) + e[3] - 1044525330 | 0, n = (n << 22 | n >>> 10) + i | 0, r += (n & i | ~n & a) + e[4] - 176418897 | 0, r = (r << 7 | r >>> 25) + n | 0, a += (r & n | ~r & i) + e[5] + 1200080426 | 0, a = (a << 12 | a >>> 20) + r | 0, i += (a & r | ~a & n) + e[6] - 1473231341 | 0, i = (i << 17 | i >>> 15) + a | 0, n += (i & a | ~i & r) + e[7] - 45705983 | 0, n = (n << 22 | n >>> 10) + i | 0, r += (n & i | ~n & a) + e[8] + 1770035416 | 0, r = (r << 7 | r >>> 25) + n | 0, a += (r & n | ~r & i) + e[9] - 1958414417 | 0, a = (a << 12 | a >>> 20) + r | 0, i += (a & r | ~a & n) + e[10] - 42063 | 0, i = (i << 17 | i >>> 15) + a | 0, n += (i & a | ~i & r) + e[11] - 1990404162 | 0, n = (n << 22 | n >>> 10) + i | 0, r += (n & i | ~n & a) + e[12] + 1804603682 | 0, r = (r << 7 | r >>> 25) + n | 0, a += (r & n | ~r & i) + e[13] - 40341101 | 0, a = (a << 12 | a >>> 20) + r | 0, i += (a & r | ~a & n) + e[14] - 1502002290 | 0, i = (i << 17 | i >>> 15) + a | 0, n += (i & a | ~i & r) + e[15] + 1236535329 | 0, n = (n << 22 | n >>> 10) + i | 0, r += (n & a | i & ~a) + e[1] - 165796510 | 0, r = (r << 5 | r >>> 27) + n | 0, a += (r & i | n & ~i) + e[6] - 1069501632 | 0, a = (a << 9 | a >>> 23) + r | 0, i += (a & n | r & ~n) + e[11] + 643717713 | 0, i = (i << 14 | i >>> 18) + a | 0, n += (i & r | a & ~r) + e[0] - 373897302 | 0, n = (n << 20 | n >>> 12) + i | 0, r += (n & a | i & ~a) + e[5] - 701558691 | 0, r = (r << 5 | r >>> 27) + n | 0, a += (r & i | n & ~i) + e[10] + 38016083 | 0, a = (a << 9 | a >>> 23) + r | 0, i += (a & n | r & ~n) + e[15] - 660478335 | 0, i = (i << 14 | i >>> 18) + a | 0, n += (i & r | a & ~r) + e[4] - 405537848 | 0, n = (n << 20 | n >>> 12) + i | 0, r += (n & a | i & ~a) + e[9] + 568446438 | 0, r = (r << 5 | r >>> 27) + n | 0, a += (r & i | n & ~i) + e[14] - 1019803690 | 0, a = (a << 9 | a >>> 23) + r | 0, i += (a & n | r & ~n) + e[3] - 187363961 | 0, i = (i << 14 | i >>> 18) + a | 0, n += (i & r | a & ~r) + e[8] + 1163531501 | 0, n = (n << 20 | n >>> 12) + i | 0, r += (n & a | i & ~a) + e[13] - 1444681467 | 0, r = (r << 5 | r >>> 27) + n | 0, a += (r & i | n & ~i) + e[2] - 51403784 | 0, a = (a << 9 | a >>> 23) + r | 0, i += (a & n | r & ~n) + e[7] + 1735328473 | 0, i = (i << 14 | i >>> 18) + a | 0, n += (i & r | a & ~r) + e[12] - 1926607734 | 0, n = (n << 20 | n >>> 12) + i | 0, r += (n ^ i ^ a) + e[5] - 378558 | 0, r = (r << 4 | r >>> 28) + n | 0, a += (r ^ n ^ i) + e[8] - 2022574463 | 0, a = (a << 11 | a >>> 21) + r | 0, i += (a ^ r ^ n) + e[11] + 1839030562 | 0, i = (i << 16 | i >>> 16) + a | 0, n += (i ^ a ^ r) + e[14] - 35309556 | 0, n = (n << 23 | n >>> 9) + i | 0, r += (n ^ i ^ a) + e[1] - 1530992060 | 0, r = (r << 4 | r >>> 28) + n | 0, a += (r ^ n ^ i) + e[4] + 1272893353 | 0, a = (a << 11 | a >>> 21) + r | 0, i += (a ^ r ^ n) + e[7] - 155497632 | 0, i = (i << 16 | i >>> 16) + a | 0, n += (i ^ a ^ r) + e[10] - 1094730640 | 0, n = (n << 23 | n >>> 9) + i | 0, r += (n ^ i ^ a) + e[13] + 681279174 | 0, r = (r << 4 | r >>> 28) + n | 0, a += (r ^ n ^ i) + e[0] - 358537222 | 0, a = (a << 11 | a >>> 21) + r | 0, i += (a ^ r ^ n) + e[3] - 722521979 | 0, i = (i << 16 | i >>> 16) + a | 0, n += (i ^ a ^ r) + e[6] + 76029189 | 0, n = (n << 23 | n >>> 9) + i | 0, r += (n ^ i ^ a) + e[9] - 640364487 | 0, r = (r << 4 | r >>> 28) + n | 0, a += (r ^ n ^ i) + e[12] - 421815835 | 0, a = (a << 11 | a >>> 21) + r | 0, i += (a ^ r ^ n) + e[15] + 530742520 | 0, i = (i << 16 | i >>> 16) + a | 0, n += (i ^ a ^ r) + e[2] - 995338651 | 0, n = (n << 23 | n >>> 9) + i | 0, r += (i ^ (n | ~a)) + e[0] - 198630844 | 0, r = (r << 6 | r >>> 26) + n | 0, a += (n ^ (r | ~i)) + e[7] + 1126891415 | 0, a = (a << 10 | a >>> 22) + r | 0, i += (r ^ (a | ~n)) + e[14] - 1416354905 | 0, i = (i << 15 | i >>> 17) + a | 0, n += (a ^ (i | ~r)) + e[5] - 57434055 | 0, n = (n << 21 | n >>> 11) + i | 0, r += (i ^ (n | ~a)) + e[12] + 1700485571 | 0, r = (r << 6 | r >>> 26) + n | 0, a += (n ^ (r | ~i)) + e[3] - 1894986606 | 0, a = (a << 10 | a >>> 22) + r | 0, i += (r ^ (a | ~n)) + e[10] - 1051523 | 0, i = (i << 15 | i >>> 17) + a | 0, n += (a ^ (i | ~r)) + e[1] - 2054922799 | 0, n = (n << 21 | n >>> 11) + i | 0, r += (i ^ (n | ~a)) + e[8] + 1873313359 | 0, r = (r << 6 | r >>> 26) + n | 0, a += (n ^ (r | ~i)) + e[15] - 30611744 | 0, a = (a << 10 | a >>> 22) + r | 0, i += (r ^ (a | ~n)) + e[6] - 1560198380 | 0, i = (i << 15 | i >>> 17) + a | 0, n += (a ^ (i | ~r)) + e[13] + 1309151649 | 0, n = (n << 21 | n >>> 11) + i | 0, r += (i ^ (n | ~a)) + e[4] - 145523070 | 0, r = (r << 6 | r >>> 26) + n | 0, a += (n ^ (r | ~i)) + e[11] - 1120210379 | 0, a = (a << 10 | a >>> 22) + r | 0, i += (r ^ (a | ~n)) + e[2] + 718787259 | 0, i = (i << 15 | i >>> 17) + a | 0, n += (a ^ (i | ~r)) + e[9] - 343485551 | 0, n = (n << 21 | n >>> 11) + i | 0, t[0] = r + t[0] | 0, t[1] = n + t[1] | 0, t[2] = i + t[2] | 0, t[3] = a + t[3] | 0;
        }
        function r(t) {
          var e,
            r = [];
          for (e = 0; e < 64; e += 4) r[e >> 2] = t.charCodeAt(e) + (t.charCodeAt(e + 1) << 8) + (t.charCodeAt(e + 2) << 16) + (t.charCodeAt(e + 3) << 24);
          return r;
        }
        function n(t) {
          var e,
            r = [];
          for (e = 0; e < 64; e += 4) r[e >> 2] = t[e] + (t[e + 1] << 8) + (t[e + 2] << 16) + (t[e + 3] << 24);
          return r;
        }
        function i(t) {
          var n,
            i,
            a,
            u,
            o,
            s,
            f = t.length,
            c = [1732584193, -271733879, -1732584194, 271733878];
          for (n = 64; n <= f; n += 64) e(c, r(t.substring(n - 64, n)));
          for (t = t.substring(n - 64), i = t.length, a = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], n = 0; n < i; n += 1) a[n >> 2] |= t.charCodeAt(n) << (n % 4 << 3);
          if (a[n >> 2] |= 128 << (n % 4 << 3), n > 55) for (e(c, a), n = 0; n < 16; n += 1) a[n] = 0;
          return u = 8 * f, u = u.toString(16).match(/(.*?)(.{0,8})$/), o = parseInt(u[2], 16), s = parseInt(u[1], 16) || 0, a[14] = o, a[15] = s, e(c, a), c;
        }
        function a(t) {
          var r,
            i,
            a,
            u,
            o,
            s,
            f = t.length,
            c = [1732584193, -271733879, -1732584194, 271733878];
          for (r = 64; r <= f; r += 64) e(c, n(t.subarray(r - 64, r)));
          for (t = r - 64 < f ? t.subarray(r - 64) : new Uint8Array(0), i = t.length, a = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], r = 0; r < i; r += 1) a[r >> 2] |= t[r] << (r % 4 << 3);
          if (a[r >> 2] |= 128 << (r % 4 << 3), r > 55) for (e(c, a), r = 0; r < 16; r += 1) a[r] = 0;
          return u = 8 * f, u = u.toString(16).match(/(.*?)(.{0,8})$/), o = parseInt(u[2], 16), s = parseInt(u[1], 16) || 0, a[14] = o, a[15] = s, e(c, a), c;
        }
        function u(t) {
          var e,
            r = "";
          for (e = 0; e < 4; e += 1) r += p[t >> 8 * e + 4 & 15] + p[t >> 8 * e & 15];
          return r;
        }
        function o(t) {
          var e;
          for (e = 0; e < t.length; e += 1) t[e] = u(t[e]);
          return t.join("");
        }
        function s(t) {
          return /[\u0080-\uFFFF]/.test(t) && (t = unescape(encodeURIComponent(t))), t;
        }
        function f(t, e) {
          var r,
            n = t.length,
            i = new ArrayBuffer(n),
            a = new Uint8Array(i);
          for (r = 0; r < n; r += 1) a[r] = t.charCodeAt(r);
          return e ? a : i;
        }
        function c(t) {
          return String.fromCharCode.apply(null, new Uint8Array(t));
        }
        function h(t, e, r) {
          var n = new Uint8Array(t.byteLength + e.byteLength);
          return n.set(new Uint8Array(t)), n.set(new Uint8Array(e), t.byteLength), r ? n : n.buffer;
        }
        function l(t) {
          var e,
            r = [],
            n = t.length;
          for (e = 0; e < n - 1; e += 2) r.push(parseInt(t.substr(e, 2), 16));
          return String.fromCharCode.apply(String, r);
        }
        function d() {
          this.reset();
        }
        var p = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
        return "5d41402abc4b2a76b9719d911017c592" !== o(i("hello")) && function (t, e) {
          var r = (65535 & t) + (65535 & e);
          return (t >> 16) + (e >> 16) + (r >> 16) << 16 | 65535 & r;
        }, "undefined" == typeof ArrayBuffer || ArrayBuffer.prototype.slice || function () {
          function e(t, e) {
            return t = 0 | t || 0, t < 0 ? Math.max(t + e, 0) : Math.min(t, e);
          }
          ArrayBuffer.prototype.slice = function (r, n) {
            var i,
              a,
              u,
              o,
              s = this.byteLength,
              f = e(r, s),
              c = s;
            return n !== t && (c = e(n, s)), f > c ? new ArrayBuffer(0) : (i = c - f, a = new ArrayBuffer(i), u = new Uint8Array(a), o = new Uint8Array(this, f, i), u.set(o), a);
          };
        }(), d.prototype.append = function (t) {
          return this.appendBinary(s(t)), this;
        }, d.prototype.appendBinary = function (t) {
          this._buff += t, this._length += t.length;
          var n,
            i = this._buff.length;
          for (n = 64; n <= i; n += 64) e(this._hash, r(this._buff.substring(n - 64, n)));
          return this._buff = this._buff.substring(n - 64), this;
        }, d.prototype.end = function (t) {
          var e,
            r,
            n = this._buff,
            i = n.length,
            a = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          for (e = 0; e < i; e += 1) a[e >> 2] |= n.charCodeAt(e) << (e % 4 << 3);
          return this._finish(a, i), r = o(this._hash), t && (r = l(r)), this.reset(), r;
        }, d.prototype.reset = function () {
          return this._buff = "", this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
        }, d.prototype.getState = function () {
          return {
            buff: this._buff,
            length: this._length,
            hash: this._hash
          };
        }, d.prototype.setState = function (t) {
          return this._buff = t.buff, this._length = t.length, this._hash = t.hash, this;
        }, d.prototype.destroy = function () {
          delete this._hash, delete this._buff, delete this._length;
        }, d.prototype._finish = function (t, r) {
          var n,
            i,
            a,
            u = r;
          if (t[u >> 2] |= 128 << (u % 4 << 3), u > 55) for (e(this._hash, t), u = 0; u < 16; u += 1) t[u] = 0;
          n = 8 * this._length, n = n.toString(16).match(/(.*?)(.{0,8})$/), i = parseInt(n[2], 16), a = parseInt(n[1], 16) || 0, t[14] = i, t[15] = a, e(this._hash, t);
        }, d.hash = function (t, e) {
          return d.hashBinary(s(t), e);
        }, d.hashBinary = function (t, e) {
          var r = i(t),
            n = o(r);
          return e ? l(n) : n;
        }, d.ArrayBuffer = function () {
          this.reset();
        }, d.ArrayBuffer.prototype.append = function (t) {
          var r,
            i = h(this._buff.buffer, t, !0),
            a = i.length;
          for (this._length += t.byteLength, r = 64; r <= a; r += 64) e(this._hash, n(i.subarray(r - 64, r)));
          return this._buff = r - 64 < a ? new Uint8Array(i.buffer.slice(r - 64)) : new Uint8Array(0), this;
        }, d.ArrayBuffer.prototype.end = function (t) {
          var e,
            r,
            n = this._buff,
            i = n.length,
            a = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          for (e = 0; e < i; e += 1) a[e >> 2] |= n[e] << (e % 4 << 3);
          return this._finish(a, i), r = o(this._hash), t && (r = l(r)), this.reset(), r;
        }, d.ArrayBuffer.prototype.reset = function () {
          return this._buff = new Uint8Array(0), this._length = 0, this._hash = [1732584193, -271733879, -1732584194, 271733878], this;
        }, d.ArrayBuffer.prototype.getState = function () {
          var t = d.prototype.getState.call(this);
          return t.buff = c(t.buff), t;
        }, d.ArrayBuffer.prototype.setState = function (t) {
          return t.buff = f(t.buff, !0), d.prototype.setState.call(this, t);
        }, d.ArrayBuffer.prototype.destroy = d.prototype.destroy, d.ArrayBuffer.prototype._finish = d.prototype._finish, d.ArrayBuffer.hash = function (t, e) {
          var r = a(new Uint8Array(t)),
            n = o(r);
          return e ? l(n) : n;
        }, d;
      });
    }, function (t, e, r) {
      function n(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      r.d(e, "a", function () {
        return u;
      });
      var i = r(0),
        a = function () {
          function t(t, e) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
          }
          return function (e, r, n) {
            return r && t(e.prototype, r), n && t(e, n), e;
          };
        }(),
        u = function () {
          function t(e, r, a) {
            var u = this;
            n(this, t), this.file = e, this.attributes = {
              filename: e.name,
              content_type: e.type,
              byte_size: e.size,
              checksum: r
            }, this.xhr = new XMLHttpRequest(), this.xhr.open("POST", a, !0), this.xhr.responseType = "json", this.xhr.setRequestHeader("Content-Type", "application/json"), this.xhr.setRequestHeader("Accept", "application/json"), this.xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest"), this.xhr.setRequestHeader("X-CSRF-Token", Object(i.d)("csrf-token")), this.xhr.addEventListener("load", function (t) {
              return u.requestDidLoad(t);
            }), this.xhr.addEventListener("error", function (t) {
              return u.requestDidError(t);
            });
          }
          return a(t, [{
            key: "create",
            value: function (t) {
              this.callback = t, this.xhr.send(JSON.stringify({
                blob: this.attributes
              }));
            }
          }, {
            key: "requestDidLoad",
            value: function (t) {
              if (this.status >= 200 && this.status < 300) {
                var e = this.response,
                  r = e.direct_upload;
                delete e.direct_upload, this.attributes = e, this.directUploadData = r, this.callback(null, this.toJSON());
              } else this.requestDidError(t);
            }
          }, {
            key: "requestDidError",
            value: function (t) {
              this.callback('Error creating Blob for "' + this.file.name + '". Status: ' + this.status);
            }
          }, {
            key: "toJSON",
            value: function () {
              var t = {};
              for (var e in this.attributes) t[e] = this.attributes[e];
              return t;
            }
          }, {
            key: "status",
            get: function () {
              return this.xhr.status;
            }
          }, {
            key: "response",
            get: function () {
              var t = this.xhr,
                e = t.responseType,
                r = t.response;
              return "json" == e ? r : JSON.parse(r);
            }
          }]), t;
        }();
    }, function (t, e, r) {
      function n(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
      }
      r.d(e, "a", function () {
        return a;
      });
      var i = function () {
          function t(t, e) {
            for (var r = 0; r < e.length; r++) {
              var n = e[r];
              n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
            }
          }
          return function (e, r, n) {
            return r && t(e.prototype, r), n && t(e, n), e;
          };
        }(),
        a = function () {
          function t(e) {
            var r = this;
            n(this, t), this.blob = e, this.file = e.file;
            var i = e.directUploadData,
              a = i.url,
              u = i.headers;
            this.xhr = new XMLHttpRequest(), this.xhr.open("PUT", a, !0), this.xhr.responseType = "text";
            for (var o in u) this.xhr.setRequestHeader(o, u[o]);
            this.xhr.addEventListener("load", function (t) {
              return r.requestDidLoad(t);
            }), this.xhr.addEventListener("error", function (t) {
              return r.requestDidError(t);
            });
          }
          return i(t, [{
            key: "create",
            value: function (t) {
              this.callback = t, this.xhr.send(this.file.slice());
            }
          }, {
            key: "requestDidLoad",
            value: function (t) {
              var e = this.xhr,
                r = e.status,
                n = e.response;
              r >= 200 && r < 300 ? this.callback(null, n) : this.requestDidError(t);
            }
          }, {
            key: "requestDidError",
            value: function (t) {
              this.callback('Error storing "' + this.file.name + '". Status: ' + this.xhr.status);
            }
          }]), t;
        }();
    }]);
  });
});
unwrapExports(activestorage);
var activestorage_1 = activestorage.start;
var activestorage_2 = activestorage.DirectUpload;
var activestorage_3 = activestorage.ActiveStorage;
function compactObject(obj) {
  var newObj = objectSpread({}, obj);
  Object.keys(newObj).forEach(function (key) {
    return newObj[key] === undefined && delete newObj[key];
  });
  return newObj;
}
var Upload = /*#__PURE__*/
function () {
  function Upload(file, options) {
    var _this = this;
    classCallCheck(this, Upload);
    defineProperty(this, "directUpload", void 0);
    defineProperty(this, "options", void 0);
    defineProperty(this, "handleChangeFile", function (upload) {
      _this.options.onChangeFile(defineProperty({}, _this.id, upload));
    });
    defineProperty(this, "handleProgress", function (_ref) {
      var loaded = _ref.loaded,
        total = _ref.total;
      var progress = loaded / total * 100;
      _this.handleChangeFile({
        state: 'uploading',
        file: _this.directUpload.file,
        id: _this.id,
        progress: progress
      });
    });
    defineProperty(this, "handleSuccess", function (signedId) {
      _this.handleChangeFile({
        state: 'finished',
        id: _this.id,
        file: _this.directUpload.file
      });
      return signedId;
    });
    defineProperty(this, "handleError", function (error) {
      _this.handleChangeFile({
        state: 'error',
        id: _this.id,
        file: _this.directUpload.file,
        error: error
      });
      throw error;
    });
    this.options = objectSpread({}, Upload.defaultOptions, compactObject(options));
    this.directUpload = new activestorage_2(file, this.directUploadsUrl, this);
    this.handleChangeFile({
      state: 'waiting',
      id: this.id,
      file: file
    });
  }
  createClass(Upload, [{
    key: "start",
    value: function start() {
      var _this2 = this;
      var promise = new Promise(function (resolve, reject) {
        _this2.directUpload.create(function (error, attributes) {
          if (error) reject(error);else resolve(attributes.signed_id);
        });
      });
      return promise.then(this.handleSuccess).catch(this.handleError);
    }
    /**
     * DirectUpload delegate protocol conformance
     */
  }, {
    key: "directUploadWillCreateBlobWithXHR",
    value: function directUploadWillCreateBlobWithXHR(xhr) {
      this.addHeaders(xhr);
      this.options.onBeforeBlobRequest && this.options.onBeforeBlobRequest({
        id: this.id,
        file: this.directUpload.file,
        xhr: xhr
      });
    }
  }, {
    key: "directUploadWillStoreFileWithXHR",
    value: function directUploadWillStoreFileWithXHR(xhr) {
      this.options.onBeforeStorageRequest && this.options.onBeforeStorageRequest({
        id: this.id,
        file: this.directUpload.file,
        xhr: xhr
      });
      xhr.upload.addEventListener('progress', this.handleProgress);
    }
    /**
     * @private
     */
  }, {
    key: "addHeaders",
    value: function addHeaders(xhr) {
      var headers = this.options.headers;
      if (headers) {
        var _arr = Object.keys(headers);
        for (var _i = 0; _i < _arr.length; _i++) {
          var headerKey = _arr[_i];
          xhr.setRequestHeader(headerKey, headers[headerKey]);
        }
      }
    }
  }, {
    key: "id",
    get: function get() {
      return "".concat(this.directUpload.id);
    }
  }, {
    key: "directUploadsUrl",
    get: function get() {
      var _this$options = this.options,
        _this$options$origin = _this$options.origin,
        host = _this$options$origin.host,
        protocol = _this$options$origin.protocol,
        port = _this$options$origin.port,
        directUploadsPath = _this$options.directUploadsPath;
      if (host) {
        var builtProtocol = protocol ? "".concat(protocol.split(':')[0], "://") : 'https://';
        var builtPort = port ? ":".concat(port) : '';
        return "".concat(builtProtocol).concat(host).concat(builtPort).concat(directUploadsPath);
      }
      return directUploadsPath;
    }
  }]);
  return Upload;
}();
defineProperty(Upload, "CONVENTIONAL_DIRECT_UPLOADS_PATH", '/rails/active_storage/direct_uploads');
defineProperty(Upload, "defaultOptions", {
  origin: {},
  directUploadsPath: Upload.CONVENTIONAL_DIRECT_UPLOADS_PATH
});
var DirectUploadProvider = /*#__PURE__*/
function (_React$Component) {
  inherits(DirectUploadProvider, _React$Component);
  function DirectUploadProvider() {
    var _getPrototypeOf2;
    var _this;
    classCallCheck(this, DirectUploadProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(DirectUploadProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(assertThisInitialized(_this)), "state", {
      uploading: false,
      fileUploads: {}
    });
    defineProperty(assertThisInitialized(assertThisInitialized(_this)), "uploads", []);
    defineProperty(assertThisInitialized(assertThisInitialized(_this)), "handleUpload", /*#__PURE__*/
    function () {
      var _ref = asyncToGenerator( /*#__PURE__*/
      regenerator.mark(function _callee(files) {
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.handleChooseFiles(files);
                return _context.abrupt("return", _this.handleBeginUpload());
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    defineProperty(assertThisInitialized(assertThisInitialized(_this)), "handleChooseFiles", function (files) {
      if (_this.state.uploading) return;
      _this.setState({
        fileUploads: {}
      });
      _this.uploads = toConsumableArray(files).map(function (file) {
        return _this._createUpload(file);
      });
    });
    defineProperty(assertThisInitialized(assertThisInitialized(_this)), "handleBeginUpload", /*#__PURE__*/
    asyncToGenerator( /*#__PURE__*/
    regenerator.mark(function _callee2() {
      var signedIds;
      return regenerator.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this.state.uploading) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _this.setState({
                uploading: true
              });
              _context2.next = 5;
              return Promise.all(_this.uploads.map(function (upload) {
                return upload.start();
              }));
            case 5:
              signedIds = _context2.sent;
              _this.props.onSuccess(signedIds);
              _this.uploads = [];
              _this.setState({
                fileUploads: {},
                uploading: false
              });
            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    })));
    defineProperty(assertThisInitialized(assertThisInitialized(_this)), "handleChangeFileUpload", function (fileUpload) {
      return _this.setState(function (_ref3) {
        var fileUploads = _ref3.fileUploads;
        return {
          fileUploads: objectSpread({}, fileUploads, fileUpload)
        };
      });
    });
    return _this;
  }
  createClass(DirectUploadProvider, [{
    key: "render",
    value: function render() {
      var fileUploads = this.state.fileUploads;
      return this.props.render({
        handleChooseFiles: this.handleChooseFiles,
        handleBeginUpload: this.handleBeginUpload,
        handleUpload: this.handleUpload,
        ready: !this.state.uploading,
        uploads: Object.keys(fileUploads).map(function (key) {
          return fileUploads[key];
        })
      });
    }
  }, {
    key: "_createUpload",
    value: function _createUpload(file) {
      var _this$props = this.props,
        directUploadsPath = _this$props.directUploadsPath,
        headers = _this$props.headers,
        onBeforeBlobRequest = _this$props.onBeforeBlobRequest,
        onBeforeStorageRequest = _this$props.onBeforeStorageRequest,
        origin = _this$props.origin;
      return new Upload(file, {
        directUploadsPath: directUploadsPath,
        headers: headers,
        onBeforeBlobRequest: onBeforeBlobRequest,
        onBeforeStorageRequest: onBeforeStorageRequest,
        onChangeFile: this.handleChangeFileUpload,
        origin: origin
      });
    }
  }]);
  return DirectUploadProvider;
}(Component);
defineProperty(DirectUploadProvider, "defaultProps", {
  origin: {}
});

/**
 * Extract the CSRF token from the <%= csrf_meta_tags %>
 *
 * @providesModule csrfHeader
 * 
 */
function getToken() {
  var meta = document.querySelector("meta[name=\"csrf-token\"]");
  return meta && meta.getAttribute('content');
}
function csrfHeader() {
  var token = getToken();
  return token ? {
    'x-csrf-token': token
  } : {};
}
var ActiveStorageProvider = /*#__PURE__*/
function (_React$Component) {
  inherits(ActiveStorageProvider, _React$Component);
  function ActiveStorageProvider() {
    var _getPrototypeOf2;
    var _this;
    classCallCheck(this, ActiveStorageProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = possibleConstructorReturn(this, (_getPrototypeOf2 = getPrototypeOf(ActiveStorageProvider)).call.apply(_getPrototypeOf2, [this].concat(args)));
    defineProperty(assertThisInitialized(assertThisInitialized(_this)), "handleSuccess", /*#__PURE__*/
    function () {
      var _ref = asyncToGenerator( /*#__PURE__*/
      regenerator.mark(function _callee(ids) {
        var data;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(ids.length === 0)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.prev = 2;
                _context.next = 5;
                return _this._hitEndpointWithSignedIds(ids);
              case 5:
                data = _context.sent;
                _this.props.onSubmit(data);
                _context.next = 12;
                break;
              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                _this.props.onError && _this.props.onError(_context.t0);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }
  createClass(ActiveStorageProvider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$endpoint = _this$props.endpoint,
        host = _this$props$endpoint.host,
        port = _this$props$endpoint.port,
        protocol = _this$props$endpoint.protocol,
        onSubmit = _this$props.onSubmit,
        props = objectWithoutProperties(_this$props, ["endpoint", "onSubmit"]);
      return /*#__PURE__*/createElement(DirectUploadProvider, _extends_1({}, props, {
        origin: {
          host: host,
          port: port,
          protocol: protocol
        },
        onSuccess: this.handleSuccess
      }));
    }
  }, {
    key: "_hitEndpointWithSignedIds",
    value: function () {
      var _hitEndpointWithSignedIds2 = asyncToGenerator( /*#__PURE__*/
      regenerator.mark(function _callee2(signedIds) {
        var _this$props2, endpoint, multiple, path, method, attribute, model, body, response;
        return regenerator.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, endpoint = _this$props2.endpoint, multiple = _this$props2.multiple;
                path = endpoint.path, method = endpoint.method, attribute = endpoint.attribute, model = endpoint.model;
                body = defineProperty({}, model.toLowerCase(), defineProperty({}, attribute, multiple ? signedIds : signedIds[0]));
                _context2.next = 5;
                return fetch(path, {
                  credentials: 'same-origin',
                  method: method,
                  body: JSON.stringify(body),
                  headers: this._headers
                });
              case 5:
                response = _context2.sent;
                if (response.ok) {
                  _context2.next = 8;
                  break;
                }
                throw response;
              case 8:
                return _context2.abrupt("return", response.json());
              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      return function _hitEndpointWithSignedIds(_x2) {
        return _hitEndpointWithSignedIds2.apply(this, arguments);
      };
    }()
  }, {
    key: "_headers",
    get: function get() {
      var headers = this.props.headers;
      var normalizedHeaders = Object.keys(headers).reduce(function (acc, key) {
        acc[key.toLowerCase()] = headers[key];
        return acc;
      }, {});
      return new Headers(objectSpread({
        accept: 'application/json',
        'content-type': 'application/json'
      }, csrfHeader(), normalizedHeaders));
    }
  }]);
  return ActiveStorageProvider;
}(Component);
defineProperty(ActiveStorageProvider, "defaultProps", {
  headers: {}
});
export default ActiveStorageProvider;
export { DirectUploadProvider };